<template>
  <div class="p-4">
    <div class="dashboard">
      Store
    </div>
    <div>
      <button class="dark-button" @click="updateStores" v-if="!loading">
        Get new stores
      </button>
      <div v-else>
        Getting Orders...
      </div>
    </div>
  </div>
</template>

<script>
import { updateStores as updateStoresApi } from "@/api/Shipstation";
export default {
  name: "StorePage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      loading: false
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    },
    updateStores() {
      this.loading = true;
      updateStoresApi()
        .then(res => {
          this.$toast.open({
            message: `Stores added ${res.storesAdded}`,
            type: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: `Error adding stores`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
